/*
  Pastel: show only the images of the selected option value.
  Tag an image by ending its alt text with #OptionName_Value, for example "Front view #Color_Black".
  Images without a # tag stay visible for every option.
*/
(function () {
  function readJSON(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function selectedTags() {
    var names = readJSON(document.getElementById('PastelProductOptions')) || [];
    var variant = readJSON(document.querySelector('variant-selects [data-selected-variant]'));
    if (!variant || !variant.options) return null;
    return names.map(function (name, i) {
      return ('#' + name + '_' + variant.options[i]).toLowerCase();
    });
  }

  function tagOf(el) {
    var img = el.querySelector('img');
    var alt = img ? img.getAttribute('alt') || '' : '';
    var idx = alt.lastIndexOf('#');
    if (idx < 0) return null;
    return alt.slice(idx).trim().toLowerCase();
  }

  function apply() {
    var tags = selectedTags();
    document.querySelectorAll('media-gallery').forEach(function (gallery) {
      var items = Array.prototype.slice.call(gallery.querySelectorAll('.product__media-item'));
      var anyTagged = items.some(function (el) {
        return tagOf(el) !== null;
      });
      var hiddenIds = {};
      var visibleCount = 0;
      items.forEach(function (el) {
        var tag = tagOf(el);
        var show = !anyTagged || !tags || tag === null || tags.indexOf(tag) !== -1;
        el.classList.toggle('px-media-hidden', !show);
        if (!show) hiddenIds[el.getAttribute('data-media-id')] = true;
        else visibleCount++;
      });
      if (anyTagged && visibleCount === 0) {
        items.forEach(function (el) {
          el.classList.remove('px-media-hidden');
        });
        hiddenIds = {};
      }
      gallery.querySelectorAll('.thumbnail-list__item').forEach(function (thumb) {
        thumb.classList.toggle('px-media-hidden', !!hiddenIds[thumb.getAttribute('data-target')]);
      });
    });
  }

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(apply, 40);
  }

  function init() {
    if (!document.getElementById('PastelProductOptions')) return;
    apply();
    var target = document.querySelector('product-info') || document.body;
    new MutationObserver(schedule).observe(target, { childList: true, subtree: true });
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('variant-selects')) schedule();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
